export default function compileSymbols(names, namespace) {
  return names.reduce((object, name) => {
    object[name] = `${namespace}/${name}`;
    return object;
  }, {});
}
